import { render, staticRenderFns } from "./statusPie.vue?vue&type=template&id=5c49b53a&scoped=true&"
import script from "./statusPie.vue?vue&type=script&lang=js&"
export * from "./statusPie.vue?vue&type=script&lang=js&"
import style0 from "./statusPie.vue?vue&type=style&index=0&id=5c49b53a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c49b53a",
  null
  
)

export default component.exports